module.exports = __webpack_public_path__ + "static/media/person_icon_black.22fb5012.svg";